// services/ticketService.ts
import axios from "axios";
import { Ticket, BaseTicket, TicketStats, TicketFilters } from "../../types/features/support/Ticket";
import { PaginatedResponse } from "../../types/utils/PaginatedResponse";
import { MAIN_API_URL } from "../../config/api";

export const ticketService = {
  // Liste paginée des tickets
  async getTickets(
    page: number = 1,
    perPage: number = 20,
    filters?: TicketFilters
  ): Promise<PaginatedResponse<Ticket>> {
    const response = await axios.get<PaginatedResponse<Ticket>>(`${MAIN_API_URL}/tickets`, {
      params: { page, per_page: perPage, ...filters },
    });
    return response.data;
  },

  async getTicketById(id: string): Promise<Ticket | null> {
    const response = await axios.get<Ticket>(`${MAIN_API_URL}/tickets/${id}`);
    return response.data;
  },

  async getTicketsByClient(
    clientId: string,
    page: number = 1,
    perPage: number = 20
  ): Promise<PaginatedResponse<Ticket>> {
    const response = await axios.get<PaginatedResponse<Ticket>>(`${MAIN_API_URL}/tickets`, {
      params: { client_id: clientId, page, per_page: perPage },
    });
    return response.data;
  },

  async createTicket(ticket: Omit<Ticket, "id" | "created_at" | "updated_at">): Promise<Ticket> {
    const response = await axios.post<Ticket>(`${MAIN_API_URL}/tickets`, ticket);
    return response.data;
  },

  async updateTicket(id: string, data: Partial<BaseTicket>): Promise<Ticket> {
    const response = await axios.put<Ticket>(`${MAIN_API_URL}/tickets/${id}`, data);
    return response.data;
  },

  async assignAgent(ticketId: string, agentId: string): Promise<Ticket> {
    const response = await axios.post<Ticket>(`${MAIN_API_URL}/tickets/${ticketId}/assign`, { agent_id: agentId });
    return response.data;
  },

  async escalateTicket(ticketId: string): Promise<Ticket> {
    const response = await axios.post<Ticket>(`${MAIN_API_URL}/tickets/${ticketId}/escalate`);
    return response.data;
  },

  async resolveTicket(ticketId: string): Promise<Ticket> {
    const response = await axios.post<Ticket>(`${MAIN_API_URL}/tickets/${ticketId}/resolve`);
    return response.data;
  },

  async deleteTicket(id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/tickets/${id}`);
  },

  // Statistiques des tickets
  async getStats(): Promise<TicketStats> {
    const response = await axios.get<TicketStats>(`${MAIN_API_URL}/tickets/stats`);
    return response.data;
  },
};
